<script>
/* Thanx to https://dikshantraj2001.medium.com/setup-google-analytics-4-with-sveltekit-1-0-64d4cbfb8b8d  */
import { analyticsStore } from "$store";
import { onMount } from "svelte";

import { PUBLIC_MEASUREMENT_ID, PUBLIC_DEBUG_MODE } from "$env/static/public";

import { page } from "$app/state";

let mounted;
onMount(() => {
  const script = document.createElement("script");
  script.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); if (${PUBLIC_DEBUG_MODE}) console.log("Debug GA4:", arguments); }
    try {
      gtag('js', new Date());
      gtag('config', '${PUBLIC_MEASUREMENT_ID}', { debug_mode: ${PUBLIC_DEBUG_MODE} });
      // console.log("Google analytics setup successfull");
    } catch (err) {
      console.log("Error setting up google analytics ", err);
    }
`;
  document.head.appendChild(script);
  mounted = true;
});

const currentPath = $derived(page.url.pathname);
// console.log("currentPath", currentPath);

$effect(() => {
  if (mounted) {
    if (typeof gtag !== "undefined") {
      // eslint-disable-next-line no-undef
      gtag("config", PUBLIC_MEASUREMENT_ID, {
        page_title: document.title,
        page_path: currentPath,
        debug_mode: PUBLIC_DEBUG_MODE,
      });
    }
  }
});
// subscribe to store and see if there is any event in store(array) then run that event
analyticsStore.subscribe((queue) => {
  let next = queue && queue.length && queue.shift();
  let retries = 3;
  let previousExecutedOperationId;
  while (next) {
    const { type, event, data, id } = next;
    if (!type || !event || !data || !id) {
      console.log("Incorrect analytics event data");
      next = queue.shift();
      continue;
    }
    // if current id is not equal to previous id then reassign retries to 3
    if (id && id !== previousExecutedOperationId) retries = 3;
    previousExecutedOperationId = id;
    if (typeof gtag !== "undefined") {
      // eslint-disable-next-line no-undef
      gtag(type, event, data);
      console.log("event created with data", next);
    } else {
      // gtag not found, retry till retries become 0
      if (retries > 0) {
        retries--;
        continue;
      } else {
        console.log("Analytics event failed to reach server with: ", next);
      }
    }
    next = queue.shift();
  }
});
</script>

<svelte:head>
  <meta name="google-site-verification" content="0YSWfZe2453Ws5qCHgsxiGd9Z3-IAdmJPVeD8sQcAFE" />
  <!-- Google tag (gtag.js) -->
  <script async src="https://www.googletagmanager.com/gtag/js?id={PUBLIC_MEASUREMENT_ID}"></script>
</svelte:head>
